<template>
  <div>
    <secondHeader />
    <div class="icon-main">
      <sidebar />
      <div class="icon-content">
        <div class="icon-container">
          <div class="content-title">
            <h2>アイコン吹き出しコメント</h2>
            <p>プレミアムコンテンツ(有料)のアイコン吹き出しコメントをカスタマイズできます。YouTube・Twitch両方に対応し、色とアイコンを変更できます。</p>
          </div>
          <div class="contents-block">
            <div class="icon-preview-area">
              <div class="chat-line__message">
                <div class="chat-line__username-container">
                  <div class="chat-author__display-name" :style="nameColorStyle">視聴者さん</div>
                </div>
                <div data-a-target="chat-line-message-body" :style="messageColorStyle">
                  こんにちは！いい天気ですね🐟
                </div>
              </div>
              <div class="chat-line__message">
                <div class="chat-line__username-container">
                  <div class="chat-author__display-name" :style="nameColorStyle">配信者さん</div>
                </div>
                <div data-a-target="chat-line-message-body" :style="messageColorStyle">
                  ありがとうございます！
                </div>
              </div>
            </div>
            <div class="set">
              <h3>アイコン選択</h3>
              <div class="icon-grid">
                <div v-for="icon in iconOptions" :key="icon.value" 
                     class="icon-option" 
                     :class="{ selected: selectedIcon === icon.value }"
                     @click="selectIcon(icon.value)">
                  <div class="icon-preview" :style="getIconStyle(icon.svg, icon.size)"></div>
                  <span class="icon-name">{{ icon.name }}</span>
                </div>
              </div>

              <h3>メインカラー選択</h3>
              <div class="color-picker-wrapper">
                <chrome-picker :value="mainColorObj" @input="updateMainColor"></chrome-picker>
              </div>

              <h3>YouTube用 コピペ用CSS</h3>
              <div class="url-description">
                <p>YouTubeのライブチャットをポップアップ表示→OBSでブラウザソースを追加し、URLを貼り付け→下記CSSをカスタムCSS欄にコピペ</p>
                <p><strong>注意:</strong> ベースCSSが必要です。先に<a href="https://ruri.info/tool/css/yt-pop.css" target="_blank" rel="noopener noreferrer">yt-pop.css</a>を適用してください。</p>
              </div>
              <div class="url-container">
                <textarea readonly class="url-input textarea" v-model="generatedYouTubeCSS" />
                <button @click="copyYouTube" class="url-copy-btn">
                  <span>コピー</span>
                </button>
              </div>

              <h3>Twitch用 コピペ用CSS</h3>
              <div class="url-description">
                <p>Twitchのコメント欄をポップアップ表示→OBSでブラウザソースを追加し、URLを貼り付け→下記CSSをカスタムCSS欄にコピペ</p>
                <p><strong>注意:</strong> ベースCSSが必要です。先に<a href="https://ruri.info/tool/css/tw-pop.css" target="_blank" rel="noopener noreferrer">tw-pop.css</a>を適用してください。</p>
              </div>
              <div class="url-container">
                <textarea readonly class="url-input textarea" v-model="generatedTwitchCSS" />
                <button @click="copyTwitch" class="url-copy-btn">
                  <span>コピー</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import secondHeader from "../../components/secondHeader.vue";
import sidebar from "../../components/sidebar.vue";
import {Chrome} from 'vue-color';

export default {
  name: "premium-iconfukidashi",
  components: {
    secondHeader,
    sidebar,
    'chrome-picker': Chrome,
  },
  data() {
    return {
      mainColor: '#419613',
      mainColorObj: {
        hex: '#419613',
        hsl: { h: 94, s: 0.68, l: 0.32, a: 1 },
        rgba: { r: 65, g: 150, b: 19, a: 1 },
        a: 1
      },
      selectedIcon: 'heart',
      iconOptions: [
        {
          value: 'heart',
          name: 'ハート',
          svg: "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3e%3cpath fill='white' d='m461.2 314c-22.6 27.4-122 109.4-173.7 151.4-18.4 15-44.7 15-63.1 0-51.7-42-151-124-173.7-151.4-34.6-41.7-50.7-81.4-50.7-124.6 0-42.2 14.4-81 40.6-109.4 26.6-28.7 62.9-44.6 102.4-44.6 29.6 0 56.6 9.4 80.4 27.8 12.4 9.7 23.4 21.1 32.5 34 9.2-12.8 20.1-24.3 32.5-34 23.8-18.5 50.9-27.8 80.5-27.8 39.6 0 75.9 15.9 102.4 44.6 26.1 28.4 40.6 67.1 40.6 109.4.1 43.2-16 82.9-50.7 124.6z'/%3e%3c/svg%3e",
          size: '40%'
        },
        {
          value: 'star',
          name: 'スター',
          svg: "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3e%3cpath fill='white' d='m21.137 11.519-2.726-.779a7.453 7.453 0 0 1 -5.151-5.151l-.779-2.726a.52.52 0 0 0 -.962 0l-.779 2.726a7.453 7.453 0 0 1 -5.151 5.151l-2.726.779a.5.5 0 0 0 0 .962l2.726.779a7.453 7.453 0 0 1 5.151 5.151l.779 2.726a.5.5 0 0 0 .962 0l.779-2.726a7.453 7.453 0 0 1 5.151-5.151l2.726-.779a.5.5 0 0 0 0-.962z'/%3e%3c/svg%3e",
          size: '50%'
        },
        {
          value: 'music',
          name: 'おんぷ',
          svg: "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3e%3cpath fill='white' d='m27 4a17.044 17.044 0 0 1 -8.772-2.43l-.713-.427a1 1 0 0 0 -1.515.857v17.111a6.993 6.993 0 1 0 2 4.889v-14.26a19.053 19.053 0 0 0 9 2.26 1 1 0 0 0 1-1v-6a1 1 0 0 0 -1-1z'/%3e%3c/svg%3e",
          size: '50%'
        },
        {
          value: 'paw',
          name: '肉球',
          svg: "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 256 256'%3e%3ccircle fill='white' cx='92.00' cy='66.99' r='24.93'/%3e%3ccircle fill='white' cx='163.00' cy='66.99' r='24.92'/%3e%3ccircle fill='white' cx='48.00' cy='114.00' r='24.93'/%3e%3ccircle fill='white' cx='208.00' cy='113.99' r='24.93'/%3e%3cpath fill='white' d=' M 166.81 117.19 C 186.41 134.74 218.94 179.61 179.06 197.47 C 148.94 210.95 104.95 210.58 74.93 195.56 C 54.77 185.47 58.19 163.68 67.19 147.19 C 78.81 125.89 97.53 106.71 120.69 98.42 C 136.23 92.86 155.24 106.82 166.81 117.19 Z'/%3e%3c/svg%3e",
          size: '55%'
        },
        {
          value: 'flower',
          name: 'フラワー',
          svg: "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3e%3cpath fill='white' d='m265.738 222.31c-5.618 4.763-13.857 4.763-19.475 0-53.24-45.132-80.615-88.932-80.615-131.957-.001-49.901 40.452-90.353 90.352-90.353s90.353 40.452 90.353 90.353c0 43.025-27.375 86.825-80.615 131.957zm0 67.38c53.24 45.132 80.615 88.932 80.615 131.957 0 49.901-40.452 90.353-90.353 90.353s-90.353-40.452-90.353-90.353c0-43.025 27.375-86.825 80.615-131.957 5.619-4.763 13.857-4.763 19.476 0zm23.952-23.952c-4.763-5.618-4.763-13.857 0-19.475 45.133-53.24 88.933-80.615 131.957-80.615 49.901-.001 90.353 40.451 90.353 90.352s-40.452 90.353-90.353 90.353c-43.025 0-86.825-27.375-131.957-80.615zm-67.38 0c-45.133 53.24-88.933 80.615-131.957 80.615-49.901 0-90.353-40.452-90.353-90.353s40.452-90.353 90.353-90.353c43.025 0 86.825 27.375 131.957 80.615 4.763 5.619 4.763 13.857 0 19.476z'/%3e%3c/svg%3e",
          size: '50%'
        },
        {
          value: 'bolt',
          name: 'サンダー',
          svg: "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512.002 512.002'%3e%3cpath fill='white' d='m201.498 512.002c-1.992 0-4.008-.398-5.934-1.229-6.741-2.907-10.387-10.266-8.617-17.39l50.724-204.178h-136.67c-4.947 0-9.576-2.439-12.373-6.52s-3.402-9.278-1.617-13.892l100.262-259.204c2.235-5.779 7.793-9.589 13.989-9.589h137.961c5.069 0 9.795 2.56 12.565 6.806 2.768 4.246 3.206 9.603 1.162 14.242l-59.369 134.76h117.42c5.486 0 10.534 2.995 13.164 7.81 2.63 4.814 2.422 10.68-.543 15.296l-209.496 326.192c-2.833 4.412-7.651 6.896-12.628 6.896z'/%3e%3c/svg%3e",
          size: '50%'
        }
      ]
    };
  },
  computed: {
    nameColorStyle() {
      const selectedIconData = this.iconOptions.find(icon => icon.value === this.selectedIcon);
      return {
        background: this.mainColor,
        '--main-color-r': this.getRGBValues().r,
        '--main-color-g': this.getRGBValues().g,
        '--main-color-b': this.getRGBValues().b,
        '--icon-url': `url("${selectedIconData.svg}")`,
        '--icon-size': selectedIconData.size || '40%'
      };
    },
    messageColorStyle() {
      return {
        borderColor: this.mainColor + '!important'
      };
    },
    generatedYouTubeCSS() {
      const rgb = this.getRGBValues();
      const selectedIconData = this.iconOptions.find(icon => icon.value === this.selectedIcon);
      
      return `:root {
  --main-color-r: ${rgb.r};
  --main-color-g: ${rgb.g};
  --main-color-b: ${rgb.b};
}

yt-live-chat-author-chip::before {
  background-image: url("${selectedIconData.svg}");
}`;
    },
    generatedTwitchCSS() {
      const rgb = this.getRGBValues();
      const selectedIconData = this.iconOptions.find(icon => icon.value === this.selectedIcon);
      
      return `:root {
  --main-color-r: ${rgb.r};
  --main-color-g: ${rgb.g};
  --main-color-b: ${rgb.b};
}

.chat-author__display-name::before {
  background-image: url("${selectedIconData.svg}");
}`;
    }
  },
  methods: {
    updateMainColor(color) {
      this.mainColorObj = color;
      this.mainColor = color.hex;
    },
    selectIcon(iconValue) {
      this.selectedIcon = iconValue;
    },
    getRGBValues() {
      return this.mainColorObj.rgba;
    },
    getIconStyle(svg, size = '40%') {
      return {
        backgroundImage: `url("${svg}")`,
        backgroundSize: size,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundColor: this.mainColor
      };
    },
    copyYouTube() {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(this.generatedYouTubeCSS);
        console.log('YouTube CSS コピー完了');
        return true;
      } else {
        return false;
      }
    },
    copyTwitch() {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(this.generatedTwitchCSS);
        console.log('Twitch CSS コピー完了');
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&display=swap');

/* Global Reset */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* Main Layout */
.icon-main {
  min-height: 100vh;
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  margin: 0 auto;
  font-family: 'Outfit', system-ui, -apple-system, sans-serif;
}

.icon-content {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  width: 100%;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
}

.icon-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  width: 100%;
}

/* Content Title */
.content-title {
  text-align: center;
  padding: 80px 0 60px 0;
}

.content-title h2 {
  font-size: 2rem;
  font-weight: 800;
  color: #0f172a;
  margin-bottom: 16px;
  letter-spacing: -0.025em;
}

.content-title p {
  font-size: 1rem;
  color: #0f172a;
  font-weight: 400;
  line-height: 1.6;
}

/* Layout Styles */
.contents-block {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-around;
  align-items: flex-start;
  margin: 24px auto;
  gap: 24px;
  padding-bottom: 80px;
}

@media screen and (max-width: 767px) {
  .icon-main {
    flex-direction: column;
  }
  
  .contents-block {
    display: block;
    margin: 0 auto;
  }

  .set {
    margin-top: 24px;
    margin-left: 0;
  }
}

.icon-preview-area {
  flex: 1;
  max-width: 420px;
  min-width: 320px;
  padding: 24px;
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
}

.set {
  flex: 1;
  max-width: 420px;
  padding: 24px;
  background-color: #ffffff;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
}

/* Preview Styles - Based on tw-pop.css */
.chat-line__message {
  width: fit-content;
  min-width: 280px;
  margin-left: 14px;
  margin-top: 22px;
  margin-bottom: 16px;
}

.chat-line__username-container {
  display: block;
}

.chat-author__display-name {
  width: fit-content;
  position: relative;
  margin-left: 30px;
  font-size: 12px;
  color: white;
  background: rgb(var(--main-color-r, 65), var(--main-color-g, 150), var(--main-color-b, 19));
  border-radius: 16px;
  padding: 4px 22px;
}

.chat-author__display-name::before {
  content: '';
  position: absolute;
  left: -35px;
  top: 0%;
  transform: translateY(-50%);
  width: 32px;
  height: 32px;
  color: white;
  border-radius: 50%;
  background-color: rgb(var(--main-color-r, 65), var(--main-color-g, 150), var(--main-color-b, 19));
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  background-image: var(--icon-url, url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3e%3cpath fill='white' d='m461.2 314c-22.6 27.4-122 109.4-173.7 151.4-18.4 15-44.7 15-63.1 0-51.7-42-151-124-173.7-151.4-34.6-41.7-50.7-81.4-50.7-124.6 0-42.2 14.4-81 40.6-109.4 26.6-28.7 62.9-44.6 102.4-44.6 29.6 0 56.6 9.4 80.4 27.8 12.4 9.7 23.4 21.1 32.5 34 9.2-12.8 20.1-24.3 32.5-34 23.8-18.5 50.9-27.8 80.5-27.8 39.6 0 75.9 15.9 102.4 44.6 26.1 28.4 40.6 67.1 40.6 109.4.1 43.2-16 82.9-50.7 124.6z'/%3e%3c/svg%3e"));
  background-size: var(--icon-size, 40%);
  background-position: center;
  background-repeat: no-repeat;
  z-index: 1;
}

.chat-author__display-name::after {
  content: '';
  position: absolute;
  left: -11px;
  top: 49%;
  transform: translateY(-50%) rotate(45deg);
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 6px 0 6px 8px;
  border-color: transparent transparent transparent rgb(var(--main-color-r, 65), var(--main-color-g, 150), var(--main-color-b, 19));
}

[data-a-target="chat-line-message-body"] {
  display: block;
  min-width: 280px;
  margin-top: -12px;
  margin-left: 24px;
  color: #5e5f61;
  font-size: 16px;
  font-weight: bold;
  padding: 18px 24px;
  background: white;
  border: 3px solid rgb(var(--main-color-r, 65), var(--main-color-g, 150), var(--main-color-b, 19));
  border-radius: 32px;
}

/* Form Styles */
h3 {
  font-size: 1.125rem;
  font-weight: 600;
  color: #0f172a;
  margin: 24px 0 12px 0;
}

h3:first-child {
  margin-top: 0;
}

/* Icon Grid */
.icon-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(80px, 1fr));
  gap: 12px;
  margin-bottom: 16px;
}

.icon-option {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 12px 8px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  background: #ffffff;
}

.icon-option:hover {
  border-color: #cbd5e1;
  background: #f8fafc;
}

.icon-option.selected {
  border-color: #0f172a;
  background: #f8fafc;
}

.icon-preview {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-size: 40%;
  background-position: center;
  background-repeat: no-repeat;
}

.icon-name {
  font-size: 11px;
  color: #64748b;
  text-align: center;
  font-weight: 500;
}

/* Color Picker */
.color-picker-wrapper {
  margin-top: 12px;
}

.color-picker-wrapper .vc-chrome {
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 0 0 1px #e2e8f0;
  font-family: system-ui, -apple-system, sans-serif;
}

.color-picker-wrapper .vc-saturation-wrap {
  border-radius: 6px 6px 0 0;
}

.color-picker-wrapper .vc-chrome-controls {
  padding: 12px;
}

.color-picker-wrapper .vc-hue,
.color-picker-wrapper .vc-alpha {
  border-radius: 4px;
  height: 12px;
}

.color-picker-wrapper .vc-chrome-fields-wrap {
  padding-top: 12px;
}

.color-picker-wrapper .vc-input__input {
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  padding: 6px 8px;
  font-size: 12px;
}

.color-picker-wrapper .vc-input__input:focus {
  border-color: #0f172a;
  outline: none;
  box-shadow: 0 0 0 1px rgba(15, 23, 42, 0.2);
}

.color-picker-wrapper .vc-input__label {
  font-size: 11px;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.025em;
}

.color-picker-wrapper .vc-chrome-color-wrap {
  border-radius: 4px;
}

.color-picker-wrapper .vc-chrome-active-color {
  border-radius: 4px;
}

/* URL Section */
.url-description {
  margin: 12px 0 16px 0;
}

.url-description p {
  font-size: 13px;
  color: #718096;
  margin: 0 0 6px 0;
  line-height: 1.5;
}

.url-description a {
  color: #0f172a;
  text-decoration: underline;
}

.url-description a:hover {
  color: #1e293b;
}

.url-container {
  display: flex;
  gap: 8px;
  align-items: stretch;
  margin-bottom: 16px;
}

.url-input {
  flex: 1;
  height: 2.4em;
  padding: 0 12px;
  border-radius: 4px;
  border: none;
  box-shadow: 0 0 0 1px #ccc inset;
  font-size: 12px;
  background: #f8fafc;
  color: #4a5568;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  line-height: 1.4;
  resize: vertical;
}

.url-input.textarea {
  height: 80px;
  padding: 12px;
  resize: vertical;
}

.url-input:focus {
  outline: none;
  box-shadow: 0 0 0 2px #0f172a;
}

.url-copy-btn {
  padding: 0 20px;
  height: 2.4em;
  background: #0f172a;
  color: #ffffff;
  border: none;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
}

.url-copy-btn:hover {
  background: #1e293b;
}

.url-copy-btn:active {
  transform: translateY(0);
}

/* Responsive Design */
@media screen and (max-width: 768px) {
  .icon-container {
    padding: 0 16px;
  }
  
  .content-title {
    padding: 60px 0 40px 0;
  }
  
  .content-title h2 {
    font-size: 1.75rem;
  }
  
  .icon-grid {
    grid-template-columns: repeat(auto-fit, minmax(70px, 1fr));
    gap: 8px;
  }
  
  .icon-option {
    padding: 10px 6px;
  }
  
  .icon-preview {
    width: 28px;
    height: 28px;
  }
  
  .chat-line__message {
    min-width: 240px;
  }
  
  [data-a-target="chat-line-message-body"] {
    min-width: 240px;
    font-size: 14px;
    padding: 16px 20px;
  }
}

@media screen and (max-width: 480px) {
  .icon-container {
    padding: 0 12px;
  }
  
  .content-title h2 {
    font-size: 1.5rem;
  }
  
  .icon-grid {
    grid-template-columns: repeat(auto-fit, minmax(60px, 1fr));
  }
  
  .set,
  .icon-preview-area {
    padding: 20px;
  }
}
</style>
